import { DynamicPageProps } from 'types/DynamicPageProps';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import { DataFormProps } from 'components/FormDynamicPageSelected/Forms/InputsTitleWithRedirect/index';

export function returListOptionsDynamicPage(
	listPages: DynamicPageProps[]
): SelectInputItemProps[] {
	const listOptions: SelectInputItemProps[] = [];

	listPages.forEach((item) => {
		listOptions.push({ id: item.id, option: item.name });
	});

	return listOptions;
}

export function canSaveLink(dataForm: DataFormProps, handleNotify: any) {
	if (dataForm.link.redirect_value === '') {
		handleNotify('Preencha o campo "Valor Redirecionamento"', 'error');
		return false;
	}

	return true;
}
